module.exports = __webpack_public_path__ + "6fe08053dacd09f944cb6be14847645c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_recency_gray.png
// module id = 57
// module chunks = 0 1 2 3 4